import { FC, useEffect, useState } from 'react';
import ProductSlide from '@/components/blog/carousel/ProductSlide';
import CarouselContainer from '@/components/layout/carouselV3/CarouselContainer';
import CarouselSlides from '@/components/layout/carouselV3/CarouselSlides';
import { useAppSelector } from '@/redux';
import { COLOR } from '@/constants/styles';

type ProductRecoCarouselProps = {
  withGap?: boolean;
  withFreeScrolling?: boolean;
  slides: {
    _id: string | number;
    seoKeyword: string;
    product: string;
    categ: string;
    image: Record<string, string>;
    isPrivate: boolean;
    isExclusiveCellar: boolean;
    item: Record<string, string>;
  }[];
  cta?: boolean;
  title?: string;
  origin?: 'fromSameProducer' | 'fromAlgolia';
  position?: 'productView' | 'sideModal' | 'blog';
}
export const ProductRecoCarousel: FC<ProductRecoCarouselProps> = ({
  withGap = false,
  withFreeScrolling = false,
  slides,
  cta = false,
  title = '',
  position = 'sideModal',
  origin = 'fromAlgolia'
}) => {
  const [finalSlides, setFinalSlides] = useState(slides);
  const isEc = useAppSelector(({ auth }) => !!auth.loggedUser?.isEc);

  useEffect(() => {
    let slidesTmp = position === 'blog' ? slides : slides.filter((slide) => slide?.item);
    if (!isEc) {
      slidesTmp = slides.filter((slide) => !slide.isPrivate && !slide.isExclusiveCellar);
    }
    setFinalSlides(slidesTmp);
  }, [slides]);

  return (
    <CarouselContainer
      title={title}
      withGap={withGap}
      withFreeScrolling={withFreeScrolling}
      renderComponent={
        (props) => (
          <CarouselSlides {...props}>
            {finalSlides.map((slide, i) => (
              <ProductSlide
                key={i} slide={slide} backgroundColor={COLOR.GREY_30} origin={origin}
                slideSize={props.state.childrenWidth} cta={cta} position={position}
              />
            ))}
          </CarouselSlides>
        )}
    />
  );
};

export default ProductRecoCarousel;
